
import i18n from "@/i18n"; // 引入 I18n 套件
export const main = {
    install(Vue, option) {
        i18n.init(option.config).then(oI18n => {
            // **************** 特殊事情
            const specialCases = ['ADHD', 'drug_sensitivity', 'asthma'];
            const specialCaseOptions = specialCases.map(key => {
                return { value: key, text: oI18n.t(`specialCaseOptions.${key}`) };
            });
            Vue.prototype.$specialCaseOptions = specialCaseOptions;

            // **************** 腰帶
            const belts = ['white', 'yellow', 'orange', 'green', 'blue', 'purple', 'brown', 'red', 'red_1', 'red_black', 'black'];
            const beltOptions = belts.map(key => {
                return { value: key, text: oI18n.t(`beltOptions.${key}`) };
            });
            Vue.prototype.$beltOptions = beltOptions;
        })

    }
}

export const excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'notify', 'blog', 'student-blog', 'video', 'website-setting', 'about-us', 'setting-holiday', 'setting-requirement', 'tutor-salary', 'enquiry'];
export const gradeList = ['toddler', 'kids', 'teen'];